import React from 'react';
import { BookOpen, Award, AlertTriangle } from 'lucide-react';
export function HiddenKnowledgeSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-137">
      <div className="max-w-5xl mx-auto" data-id="element-138">
        <div className="flex items-center justify-center mb-10" data-id="element-139">
          <BookOpen size={32} className="text-teal-700 mr-3" data-id="element-140" />
          <h2 className="text-3xl font-bold text-gray-800" data-id="element-141">
            What Science Has Discovered
          </h2>
        </div>
        <div className="bg-teal-50 rounded-lg p-6 mb-10" data-id="element-142">
          <div className="flex items-start mb-6" data-id="element-143">
            <Award size={28} className="text-teal-700 mr-3 mt-1 flex-shrink-0" data-id="element-144" />
            <div data-id="element-145">
              <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-146">
                Backed by Science
              </h3>
              <p className="text-lg text-gray-700" data-id="element-147">
                Recent studies from the American Heart Association, Harvard
                Medical School, and the CDC confirm something nobody tells you:
              </p>
              <p className="text-xl font-bold text-teal-700 mt-4" data-id="element-148">
                "Up to 80% of cases of high cholesterol, prediabetes, and type 2
                diabetes could be reversed with strategic nutrition."
              </p>
            </div>
          </div>
        </div>
        <div className="mb-10" data-id="element-149">
          <h3 className="text-2xl font-semibold text-center text-gray-800 mb-6" data-id="element-150">
            The problem? No one taught you how to eat to heal.
          </h3>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-151">
            <div className="bg-white rounded-lg shadow-md p-5" data-id="element-152">
              <div className="flex items-center mb-4" data-id="element-153">
                <AlertTriangle size={24} className="text-orange-500 mr-2" data-id="element-154" />
                <h4 className="text-lg font-medium text-gray-800" data-id="element-155">
                  "Vegetable" Oils
                </h4>
              </div>
              <p className="text-gray-700" data-id="element-156">
                They keep promoting "vegetable" oil that silently inflames your
                body.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-md p-5" data-id="element-157">
              <div className="flex items-center mb-4" data-id="element-158">
                <AlertTriangle size={24} className="text-orange-500 mr-2" data-id="element-159" />
                <h4 className="text-lg font-medium text-gray-800" data-id="element-160">
                  Disguised Sugar
                </h4>
              </div>
              <p className="text-gray-700" data-id="element-161">
                "Light" products full of sugar disguised under scientific names.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-md p-5" data-id="element-162">
              <div className="flex items-center mb-4" data-id="element-163">
                <AlertTriangle size={24} className="text-orange-500 mr-2" data-id="element-164" />
                <h4 className="text-lg font-medium text-gray-800" data-id="element-165">
                  Dangerous Breakfasts
                </h4>
              </div>
              <p className="text-gray-700" data-id="element-166">
                Breakfasts that hijack your energy and spike your glucose from
                early morning.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}